import { gql } from '@apollo/client'

export const CONTACT_LEGAL_STATUSES_OPTIONS_QUERY = gql`
  query getLegalStatus($countryConfigId: ID!) {
    legalStatuses(countryConfigId: $countryConfigId) {
      id
      name
    }
  }
`
